import React from 'react';
import { observer, useLocalStore } from 'mobx-react-lite';
import { DialogState } from '../../../commonv3/states/dialogState';
import { Confirmation } from '../../components/molecules/modals/Confirmation';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';
import { action, observable, makeObservable } from 'mobx';
import { MokumokuStudyRoomEntriesApis } from '../../apis/mokumoku_study_room_entries';
import { MokumokuStudyRoomUrlApis } from '../../apis/mokumoku_study_room_url';
import { MokumokuStudyRoomUrl } from '../../../commonv3/types/mokumokuStudyRoomUrl';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../commonv3/api/RemoteResourceV3';

class State {
  constructor() {
    makeObservable(this, {
      mokumokuStudyRoom: observable,
      open: action.bound,
      entryMokumokuStudyRoom: action.bound,
    });
  }

  mokumokuStudyRoom: RemoteResourceV3<MokumokuStudyRoomUrl | null> = RemoteResourceV3.loading();
  dialog: DialogState = new DialogState();

  async init() {
    await this.findMokumokuStudyRoomUrl();
  }

  open() {
    this.dialog.open();
  }

  get isOpen() {
    return this.dialog.isOpen;
  }

  async entryMokumokuStudyRoom() {
    try {
      await this.findMokumokuStudyRoomUrl();
      if (!this.mokumokuStudyRoom.value) throw new Error("couldn't get mokumokuStudyRoom resource");
      if (this.mokumokuStudyRoom.value) {
        await MokumokuStudyRoomEntriesApis.create();
        GlobalStatesV3.routing.push(V3Routes.mokumoku());
        window.open(this.mokumokuStudyRoom.value.url, '_blank');
      } else return;
    } catch {
      alert('もくもく自習室の入室に失敗しました。ページを更新してください。');
    }
  }

  private async findMokumokuStudyRoomUrl() {
    await updateRemoteResourceV3(
      this.mokumokuStudyRoom,
      (v) => (this.mokumokuStudyRoom = v),
      () => MokumokuStudyRoomUrlApis.show()
    );
  }
}

export const MokuMokuStudyRoom = observer(() => {
  const { pageState } = useLocalStore(() => ({
    pageState: new State(),
  }));
  pageState.open();

  return (
    <Confirmation
      headerMessage="もくもく自習室に参加しますか？"
      message=""
      confirmationText="参加する"
      open={pageState.isOpen}
      onAbort={() => GlobalStatesV3.routing.push(V3Routes.mokumoku())}
      onConfirmation={pageState.entryMokumokuStudyRoom}
    />
  );
});
